import React from 'react'
import { HasDataProviderContext } from 'data/DataProvider'

// this is lazy loaded to avoid requiring data/records in embeds bundle
const ConnectedLocaleProvider = React.lazy(() => import('./ConnectedLocaleProvider'))
const StandaloneLocaleProvider = React.lazy(() => import('./StandaloneLocaleProvider'))

// since our default messages are all in English, the 'en' locale
// will always be empty
export const languageStrings = async language => import('langs/' + language + '.json')
  .then(module => module.default)

export class LocaleProvider extends React.PureComponent {
  render () {
    return (
      <HasDataProviderContext.Consumer>
        {hasDataProvider => hasDataProvider
          ? <React.Suspense fallback={<></>}>
            <ConnectedLocaleProvider {...this.props} />
          </React.Suspense>
          : <React.Suspense fallback={<></>}>
            <StandaloneLocaleProvider {...this.props} />
          </React.Suspense>}
      </HasDataProviderContext.Consumer>
    )
  }
}
